import React from 'react';
import IncidentsComponent from './Incidents/index.jsx';
import Header from './Header';
import './App.scss';
import ProtectedPage from './ProtectedPage';
import { getBaseUrl } from './utils';
import { withRouter } from 'react-router-dom';
import PoweredBy from './PoweredBy';

const baseUrl = getBaseUrl();

class Incident extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      incident: props.history.location.incident,
      statuspage: props.history.location.statuspage,
      incidentId: null,
      protected: false,
      protectedPageData: {}
    }
  }

  componentDidMount() {
    const { incidentId } = this.props.match.params;

    if (!!this.props.match && !!this.props.match.params && !!this.props.match.params.id) {
      const { id } = this.props.match.params;

      this.setState({ statusPageId: id, incidentId }, () => {
        this.fetchIncident();
      });
    } else {
      const { hostname } = window.location;

      this.setState({ statusPageId: hostname, incidentId }, () => {
        this.fetchIncident();
      });
    }
  }

  fetchStatuspage = () => {
    if (!!this.state.statuspage) {
      this.setTabName();
      this.setFavicon();
      return null;
    }

    fetch(`${baseUrl}/api/v1/public/services/${this.state.statusPageId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.message === 'Unauthorized') {
          this.setState({ protected: true, protectedPageData: response.data });
        }
        return response;
      })
      .then((response) => response.data)
      .then((statuspage) => {
        this.setState({ statuspage }, () => {
          this.setTabName();
          this.setFavicon();
        });
      });
  }


  fetchIncident() {
    if (!!this.state.incident) {
      return;
    }
    const { incidentId } = this.state;
    const { hostname } = window.location;

    fetch(`${baseUrl}/api/v1/incident/${hostname}/${incidentId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include'
      })
      .then(response => response.json())
      .then((response) => {
        this.setState({ incident: response.data });
      });

    if (!this.state.statuspage) {
      this.fetchStatuspage();
    } else {
      this.setTabName();
    }
  }

  setTabName() {
    document.title = this.state.statuspage.name + ' Incidents';
  }

  hasFavicon() {
    return !!this.state.statuspage.favicon && this.state.statuspage.favicon.length
  }

  setFavicon() {
    let favicon = ''

    if (this.hasFavicon()) {
      favicon = this.state.statuspage.favicon 
      document.querySelector("link[rel='shortcut icon']").href = favicon;
    }
  }

  render() {
    if (this.state.protected) {
      return (
        <ProtectedPage
          data={this.state.protectedPageData}
        />
      )
    }

    const { incident, statuspage } = this.state;
    if (!statuspage) {
      return null;
    }

    return (
      <div>
        {<Header statuspage={statuspage} />}

        {!!incident
          && <IncidentsComponent statuspage={statuspage} statusPageId={this.state.statusPageId} isHomePage={false} isIncidentPage={true} incidents={[incident]} />
        }
        <div className="right-wrapper">
          <PoweredBy />
        </div>
      </div>
    );
  }
}

export default withRouter(Incident);
